<div class="wrapper">
    <!-- *ngIf="showHeaderFooter" -->
    <app-header-personal [user]="user"></app-header-personal>
    <div class="main-content">
        <div *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></div>
        <router-outlet (activate)="setStaticContent()"></router-outlet>
    </div>
    <app-footer></app-footer>
</div>